const breakpointJson = require('customtheme.json').breakpoint;

export const breakpoint = {
  sm: '750px',
  md: '1024px',
  mdlg: '1200px',
  lg: '1440px',
  xl: '2500px',
  ...breakpointJson,
};
